import React from 'react'
import * as s from './HowTo.module.scss'
import Exchanges from '../Exchanges'

const HowTo = () => {
  return (
    <section id="how" className={s.how_to}>
      <Exchanges />
    </section>
  )
}

export default HowTo
